import type { AppManifest, CustomActionConfig } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { shouldAddManageMemberAccessAction } from '../../../../utils/experiments';
import { AppManagerAction } from '../../types';

type CustomAppActions = NonNullable<AppManifest['appDescriptor']>['customActions'];

type MainAppActions = NonNullable<AppManifest['appDescriptor']>['mainActions'];

const getMainAppActions = async (t: TranslationFunction): Promise<MainAppActions> => {
  return [
    {
      actionId: AppManagerAction.OpenCustomizeMemberPage,
      icon: 'appManager_settingsAction',
      title: t('Apps_Manager_Customize_Member_Page'),
    },
  ];
};

const getCustomAppActions = async (t: TranslationFunction): Promise<CustomAppActions> => [
  {
    actionId: AppManagerAction.OpenMembersAccountBmDashboard,
    type: 'dashboard',
    icon: 'appManager_settingsAction',
    title: t('Apps_Manager_Customize_Members_Profiles'),
  },
  {
    actionId: AppManagerAction.OpenBadgesDashboard,
    type: 'dashboard',
    icon: 'addAction',
    title: t('Apps_Manager_Open_Badges_Page'),
  },
  {
    actionId: AppManagerAction.OpenMembersAddPanel,
    type: 'editorActions',
    icon: 'appManager_addElementsAction',
    title: t('Apps_Manager_Open_Members_Add_Panel'),
  },
  {
    actionId: AppManagerAction.OpenMembersAreaPagesPanel,
    type: 'editorActions',
    icon: 'appManager_pagesAction',
    title: t('Apps_Manager_Manage_Member_Pages'),
  },
  {
    actionId: AppManagerAction.OpenSiteMembersDashboard,
    type: 'dashboard',
    icon: 'appManager_memberAction',
    title: t('Apps_Manager_Engage_With_Your_Members'),
  },
  ...((await shouldAddManageMemberAccessAction())
    ? [
        {
          actionId: AppManagerAction.OpenSiteMembersAccessDashboard,
          type: 'dashboard',
          icon: 'passkey',
          title: t('Apps_Manager_Manage_Member_Access'),
        } as CustomActionConfig,
      ]
    : []),
];

export const getAppDescriptor = async (t: TranslationFunction): Promise<AppManifest['appDescriptor']> => {
  return {
    mainActions: await getMainAppActions(t),
    defaultActions: { learnMoreKB: 'b74bcbba-91c8-4951-a3de-a1dc698f6356' },
    customActions: await getCustomAppActions(t),
  };
};
